import { render, staticRenderFns } from "./PrintableForm.vue?vue&type=template&id=0f5204a0&scoped=true&lang=pug&"
import script from "./PrintableForm.vue?vue&type=script&lang=js&"
export * from "./PrintableForm.vue?vue&type=script&lang=js&"
import style0 from "./PrintableForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrintableForm.vue?vue&type=style&index=1&id=0f5204a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5204a0",
  null
  
)

export default component.exports